import cn from 'classnames'
import styles from './styles.module.scss'

interface IProps {
    isStopped: boolean
}

export const MovingHorizontalDots = ({ isStopped }: IProps) => {
    const dots = Array.from({ length: 9 }, (_, i) => (
        <div key={i} className={styles.dot} />
    ))

    return (
        <div className={styles.dotsHorizontalContainer}>
            <div
                className={cn(styles.dotsTrack, {
                    [styles.animate]: !isStopped,
                })}
            >
                <div className={styles.dotsGroup}>{dots}</div>
                <div className={`${styles.dotsGroup} ${styles.second}`}>
                    {dots}
                </div>
            </div>
        </div>
    )
}
